// 模板中心埋点p1（表示是产品的埋点）
export const PRODUCT = 'product';

export const LABEL_MAP: { [key: string]: { name: string; color: string } } = {
    official: {
        name: 'official',
        color: 'blue'
    },
    kit: {
        name: 'kit',
        color: 'yellow'
    },
    popular: {
        name: 'popular',
        color: 'red'
    }
};

export const ALL_CATE_MAP = {
    SCENE: 'all_scene',
    INDUSTRY: 'all_industry'
};

export const DEFAULT_SOLUTION_SEARCH_PARAMS = {
    keyword: '',
    category: ALL_CATE_MAP.SCENE,
    industry: ALL_CATE_MAP.INDUSTRY
};
